class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.isUpdating = false;
    this.bindEvents();
  }
  
  bindEvents() {
    if(document.querySelector("#minicart-drawer-toggle")){
      document.querySelector("#minicart-drawer-toggle").addEventListener('click', this.openDrawer.bind(this))
    }
    this.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
      button.addEventListener('click', this.closeDrawer.bind(this))
    );
  }
  
  openDrawer(event) {
    event.preventDefault();
    this.isUpdating = true;
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const cartDrawerElement = doc.querySelector('cart-drawer');
        
        if (cartDrawerElement) {
          const minicartElement = document.getElementById('minicart');
          minicartElement.innerHTML = cartDrawerElement.innerHTML;
          
          const miniCartInner = minicartElement.querySelector('mini-cart');
          if (miniCartInner) {
            miniCartInner.removeAttribute('data-cart-count');
          }
        }
        
        if(document.querySelector("#cart-upsell-product")){
          themeSlidersInit($("#cart-upsell-product"));
        }
        
        document.querySelector("#minicart").classList.add("active");
        document.querySelector("body").classList.add("no-scroll");

        this.bindCloseEvents();
        
        setTimeout(() => {
          trapFocusElements(document.querySelector("#minicart"))
          this.isUpdating = false;
        }, 500)
        
        setTimeout(() => {
          fetch("/cart.js")
            .then(response => response.json())
            .then((data) => {
              let totalprice = data.total_price;
              shippingProgressBar(totalprice)
            })
        }, 500)
      })
      .catch(e => {
        console.error(e);
        this.isUpdating = false;
      });
  }
  
  bindCloseEvents() {
    this.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
      button.addEventListener('click', this.closeDrawer.bind(this))
    );
  }
  
  renderContents(parsedState) {
    if (this.isUpdating) {
      console.log('Skipping renderContents during initial load');
      return;
    }
    
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(parsedState.sections[section.id], 'text/html');
        const cartDrawerElement = doc.querySelector('cart-drawer');
        
        if (cartDrawerElement) {
          const targetElement = document.querySelector(section.selector);
          if (targetElement) {
            targetElement.innerHTML = cartDrawerElement.innerHTML;
            
            const miniCartInner = targetElement.querySelector('mini-cart');
            if (miniCartInner) {
              miniCartInner.removeAttribute('data-cart-count');
            }
          }
        }
        
        if(document.querySelector("#cart-upsell-product")){
          themeSlidersInit($("#cart-upsell-product"));
        }

        let totalCount = doc.querySelector("mini-cart")?.getAttribute("data-cart-count") || "0";
        
        if(document.querySelector("[data-header-cart-count]")){
          const headerCount = document.querySelector("[data-header-cart-count]");
          
          if(headerCount.classList.contains("hidden")){
            headerCount.classList.remove("hidden")
          }
          
          if(totalCount == 0){
            headerCount.classList.add("hidden")
          }
          else if(totalCount < 100){
            headerCount.textContent = totalCount;
          } else {
            headerCount.textContent = '';
          }
        }

        this.bindCloseEvents();
      }
    }));
    
    setTimeout(() => {
      fetch("/cart.js")
        .then(response => response.json())
        .then((data) => {
          let totalprice = data.total_price;
          shippingProgressBar(totalprice)
        })
    }, 500)
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'cart-drawer',
        selector: 'cart-drawer'
      }
    ];
  }
  
  getSectionInnerHTML(html, selector = 'cart-drawer') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }
  
  closeDrawer(event){
    event.preventDefault();
    const closeElement = event.currentTarget;
    if(closeElement.closest(".side-drawer-panel").classList.contains("active")){
      closeElement.closest(".side-drawer-panel").classList.remove("active");
      document.querySelector("body").classList.remove("no-scroll");
    }
  }
}

customElements.define('cart-drawer', MiniCart);